import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import { notifApi } from '../../communicationCampaign/api/campaign.api';
import { EMarketingDTO } from '../type';

export const eMarketingApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 20000 });

export const createEMarketingApi = async (eMarketing: EMarketingDTO) =>
  eMarketingApi.api.post<EMarketingDTO>(`/api/v2/emarketings`, eMarketing);

export const updateEMarketingApi = async (eMarketing: EMarketingDTO) =>
  eMarketingApi.api.put<EMarketingDTO>(`/api/v2/emarketings/${eMarketing.id}`, eMarketing);

export const getOfficialEMarketingApi = async (franchiseId: string) => {
  try {
    const response = await notifApi.api.get<EMarketingDTO>(`api/v2/users/${franchiseId}/emarketing`);
    return response.data;
  } catch (error: any) {
    if (error.response.data.error.status === 'EMARKETING_NOT_FOUND') {
      return undefined;
    }
    throw error;
  }
};

export const getEMarketingAvailabilityApi = async (identifier: string) =>
  eMarketingApi.api.get(`/api/v2/emarketings/${identifier}/availability`);
